import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/share/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/dearest/share",
)({
  component: Page,
});
